<template>
  <div class="change-phone">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toAccountSetting">账号设置/</span>更改手机
      </template>
      <template v-slot:content>
        <div class="main">
          <div class="main-content">
            <div class="step">
              <div :class="active>=0?'next':''">
                <i class="phone_people"></i>
                <span>验证身份</span>
              </div>
              <p :class="active>=0?'active':''"></p>
              <div :class="active>=1?'next':''">
                <i class="phone_phone"></i>
                <span>修改手机</span>
              </div>
              <p :class="active>=1?'active':''"></p>
              <div :class="active>=2?'next':''">
                <i class="phone_success"></i>
                <span>完成</span>
              </div>
            </div>
            <div class="content">
              <div v-if="active==0" class="form">
                <el-form
                  :model="Register"
                  ref="RegisterForm"
                  label-width="80px"
                  class="RegisterForm"
                >
                  <el-form-item prop="phone" label="原手机：">
                    <el-input disabled class="disabled" v-model="Register.phone"></el-input>
                  </el-form-item>
                  <el-form-item prop="验证码" class="code" label="验证码：">
                    <el-input class="gray" v-model="Register.code"></el-input>
                    <el-button
                      type="text"
                      class="btntext"
                      @click="sendcode(Register.phone)"
                      :disabled="disabled"
                    >{{ btntxt }}</el-button>
                  </el-form-item>
                </el-form>
                <el-button class="btn-blue" @click="next">下一步</el-button>
              </div>
              <div v-if="active==1" class="form">
                <el-form
                  :model="Register2"
                  ref="RegisterForm"
                  label-width="80px"
                  class="RegisterForm"
                >
                  <el-form-item prop="phone" label="手机号：">
                    <el-input class="gray" v-model="Register2.phone"></el-input>
                  </el-form-item>
                  <el-form-item prop="sendcode" class="code" label="验证码：">
                    <el-input class="gray" v-model="Register2.code"></el-input>
                    <el-button
                      type="text"
                      @click="sendNewCode(Register2.phone)"
                      class="btntext"
                      :disabled="disabled"
                    >{{btntxt}}</el-button>
                  </el-form-item>
                </el-form>
                <el-button class="btn-blue" @click="submit">下一步</el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBUser from 'models/db/user.js';
const dbUser = new DBUser();
export default {
  data() {
    return {
      active: 0,
      Register: {
        phone: '',
        code: ''
      },
      Register2: {
        phone: '',
        code: ''
      },
      // 发送验证码状态
      disabled: false,
      time: 0,
      btntxt: '发送验证码'
    };
  },
  components: {
    SecondMenuLinkContent
  },
  created() {
    this.Register.phone = this.$route.query.telephone;
  },
  methods: {
    toAccountSetting() {
      this.$router.push('account-setting');
    },
    // 手机验证发送验证码
    sendcode(Tphone) {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.Register.phone === '') {
        this.$message({
          message: '手机号不能为空',
          center: true
        });
        return;
      }
      if (!reg.test(this.Register.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true
        });
      } else {
        let telephone = Tphone;
        dbUser.getDBSendCode(telephone).then(res => {
          if (res.success) {
            this.$message({
              message: '发送成功',
              type: 'success',
              center: true
            });
            this.time = 60;
            this.disabled = true;
            this.timer();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 新手机号发送验证码
    sendNewCode(Tphone) {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.Register.phone === '') {
        this.$message({
          message: '手机号不能为空',
          center: true
        });
        return;
      }
      if (!reg.test(this.Register.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true
        });
      } else {
        let telephone = Tphone;
        dbUser.postDBSendCode(telephone).then(res => {
          if (res.success) {
            this.$message({
              message: '发送成功',
              type: 'success',
              center: true
            });
            this.time = 60;
            this.disabled = true;
            this.timer();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + 's后重试';
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = '获取验证码';
        this.disabled = false;
      }
    },
    // 下一步
    next() {
      let telephone = this.Register.phone;
      let code = this.Register.code;
      if (telephone && code) {
        dbUser.getDBCheckCode(telephone, code).then(res => {
          if (res.success) {
            this.disabled = false;
            this.time = 0;
            this.btntxt = '发送验证码';
            this.active = 1;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error('请输入验证码');
      }
      // if (this.active < 1) {
      //   this.active++;
      //   this.$refs['RegisterForm'].resetFields();
      //   this.Register.sendcode = '';
      // } else {
      //   this.$router.push('account-setting');
      //   this.$message({
      //     message: '修改成功',
      //     type: 'success',
      //     center: true
      //   });
      //   // location.reload()
      // }
    },
    // 修改手机
    submit() {
      let newTelephone = this.Register2.phone;
      let newTelephoneCode = this.Register2.code;
      let telephone = this.Register.phone;
      let code = this.Register.code;
      let data = {
        telephone,
        code
      };
      if (newTelephone && newTelephoneCode) {
        dbUser
          .getDBChangeTelephone(newTelephone, newTelephoneCode, data)
          .then(res => {
            if (res.success) {
              this.$router.push('account-setting');
              this.$message({
                message: '修改成功',
                type: 'success',
                center: true
              });
            } else {
              this.$message.error(res.message);
            }
          });
      } else {
        this.$message.error('手机号或验证码不为空');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.change-phone {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .main {
    .main-content {
      padding: 0 300px;
      .step {
        padding-top: 56px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        width: 100%;
        > div {
          width: 106px;
          height: 32px;
          display: flex;
          align-items: center;
          font-size: 16px;
          i {
            width: 32px;
            height: 32px;
            margin-right: 6px;
            border-radius: 50%;
          }
          .phone_phone {
            background: url(../../../../assets/images/phone_phone.png);
          }
          .phone_success {
            background: url(../../../../assets/images/phone_success.png);
          }
        }
        > p {
          flex: 1;
          height: 1px;
          background-color: #919398;
          margin: 0 15px;
        }
        > .active {
          background-color: #3d74f2;
        }
        .next {
          color: #3d74f2;
          i {
            background-color: #3d74f2;
          }
          .phone_people {
            background: url(../../../../assets/images/phone_people.png);
          }
          .phone_phone {
            background: url(../../../../assets/images/phone_phone_bj.png);
          }
        }
      }
      .content {
        margin-top: 66px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        letter-spacing: 1px;
        .btn-blue {
          width: 300px;
          margin-left: 80px;
          letter-spacing: 4px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.change-phone {
  .main {
    .main-content {
      .content {
        .form {
          width: 450px;
          font-size: 14px;
          .el-form {
            width: 100%;
            padding: 0;
            .el-form-item {
              margin-bottom: 20px;
              .el-form-item__content {
                position: relative;
                width: 300px;
              }
              .btntext {
                font-size: 14px;
                width: 78px;
                position: absolute;
                top: 0px;
                color: rgba(61, 116, 242, 1);
              }
            }
          }
        }
      }
    }
  }
}
</style>
